export {default as EdgeDailyTracker} from './EdgeDailyTracker.connect';
